import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpand: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="expand, window, layout"><path d="M3.75 10.25V3.75H21.25V15.25H14.75M17.25 10.75V7.75H14.25M14 11L16.7465 8.25346M11.25 13.75H2.75V21.25H11.25V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconExpand;
